/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import * as interactions from '../readonlyInteractions/index.js';

export default {
    name: 'readonly',
    /**
     * Returns the interaction components used by the readonly renderer.
     * @returns {Object<string, SvelteComponent>} interaction name to Svelte component map
     */
    getInteractions() {
        return interactions;
    }
};
